import {Grid} from '@mui/material';

import {ComparisonKey} from './ComparisonKey';
import {ComparisonCard} from '../../../../../components/ComparisonCard/ComparisonCard';
import {empionGreen, empionOrange} from '../../../../../layouts/theme/EmpionColors';
import {CultureMatchItem} from '../../../dashboard/types/ApplicantMatchesTypes';

interface Props {
  cultureMatchItems: CultureMatchItem[];
  companyName: string;
  applicantName: string;
  detailedCardView?: boolean;
}

export const CultureComparison = ({cultureMatchItems, companyName, applicantName, detailedCardView}: Props) => {
  const barColor = empionOrange[4];

  return (
    <Grid container flexDirection='column' alignItems='center'>
      <Grid item paddingBottom='40px'>
        <Grid
          container
          item
          justifyContent='center'
          sx={{
            backgroundColor: empionOrange[detailedCardView ? 5 : 4],
            borderRadius: '8px',
          }}
          gap='32px'
        >
          <ComparisonKey name={companyName} barColor={empionGreen[100]} />
          <ComparisonKey name={applicantName} barColor={empionOrange[100]} />
        </Grid>
      </Grid>
      <Grid item container xs={12} md={detailedCardView ? 12 : 6}>
        {cultureMatchItems.map((item) => (
          <Grid item key={item.resourceId} xs={12}>
            <ComparisonCard
              methodItem={{title: item.title, scaleConfiguration: item.scaleConfiguration}}
              overlap={Math.round((item?.overlap || 0) * 100)}
              firstIndicatorValue={item.applicantValue}
              secondIndicatorValue={item.companyValue}
              barColor={barColor}
              paperBackgroundColor={detailedCardView ? empionOrange[5] : 'white'}
              bubbleSize={40}
            />
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
};
